"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _qrcode = _interopRequireDefault(require("qrcode.react"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /*
 * Copyright (C) 2018 Nettoken Ltd. All rights reserved.
 *
 * This document is the property of Nettoken Ltd.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Nettoken Ltd.
 */
var QR = function QR(_ref) {
  var blurred = _ref.blurred,
    loading = _ref.loading,
    onRefresh = _ref.onRefresh,
    refreshable = _ref.refreshable,
    refreshString = _ref.refreshString,
    value = _ref.value,
    loadingText = _ref.loadingText;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(_defineProperty(_defineProperty({}, _style["default"].code, true), _style["default"]._blurred, value && (blurred || loading || refreshable)))
  }, /*#__PURE__*/_react["default"].createElement(_qrcode["default"], {
    bgColor: "transparent",
    className: (0, _classnames["default"])(_defineProperty({}, _style["default"].hidden, !value)),
    level: "L",
    value: value
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(_defineProperty(_defineProperty({}, _style["default"].loader, true), _style["default"]._hidden, !!value && !loading && !refreshable))
  }), loading && /*#__PURE__*/_react["default"].createElement("span", {
    className: _style["default"].loadingText
  }, loadingText), refreshable && /*#__PURE__*/_react["default"].createElement("button", {
    className: _style["default"].button,
    onClick: onRefresh
  }, refreshString));
};
var _default = exports["default"] = QR;